module.exports = __webpack_public_path__ + "img/en.christine.6fa0d2ba.jpg";